/* eslint-disable no-console */
import { makeAutoObservable, runInAction } from 'mobx';
import { ImportTypeEnum } from '@app/common';
import { ImportTypeEnum as ApiImportTypeEnum } from '../../defs/api';
import type { RootStore } from './root-store';
import { ImporterMobxDto } from '../mobx/dtos/importer/importer-mobx-dto';

export class ImporterStore {
    rootStore: RootStore;

    importers: ImporterMobxDto[] | null = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this, { rootStore: false });
    }

    async fetchImporters(): Promise<void> {
        if (this.importers) return;

        try {
            const fetchedImporters = await this.rootStore.apiClient.importerController.importerControllerGetList();
            runInAction(() => {
                this.importers = ImporterMobxDto.createFromArray(fetchedImporters);
            });
        } catch (e) {
            console.error(e);
        }
    }

    getImporterConfig(type: ImportTypeEnum): ImporterMobxDto | undefined {
        if (!this.importers) return undefined;

        return this.importers.find((importer) => importer.id === (type as unknown as ApiImportTypeEnum));
    }
}
